var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "value": _vm.dialog,
      "max-width": "600",
      "persistent": ""
    },
    on: {
      "input": _vm.closeModal
    }
  }, [_c('v-card', {
    staticClass: "card"
  }, [_c('v-card-title', {
    staticClass: "headline accent--text pb-4"
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? 'Редактировать' : 'Добавить') + " ")]), _c('v-card-text', {
    attrs: {
      "outlined": "",
      "tile": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.dictionaries.applicationType,
      "item-text": "name",
      "label": "Тип заявления",
      "placeholder": "Выберите из списка",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "return-object": "",
      "error-messages": _vm.errorMessages.applicationType
    },
    on: {
      "input": function input($event) {
        return _vm.$v.blockTrigger.applicationType.$touch();
      },
      "blur": function blur($event) {
        return _vm.$v.blockTrigger.applicationType.$touch();
      }
    },
    model: {
      value: _vm.blockTrigger.applicationType,
      callback: function callback($$v) {
        _vm.$set(_vm.blockTrigger, "applicationType", $$v);
      },
      expression: "blockTrigger.applicationType"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.dictionaries.submissionSession,
      "item-text": "submissionName",
      "label": "Период подачи",
      "placeholder": "Выберите из списка",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "return-object": "",
      "error-messages": _vm.errorMessages.submissionSession
    },
    on: {
      "input": function input($event) {
        return _vm.$v.blockTrigger.submissionSession.$touch();
      },
      "blur": function blur($event) {
        return _vm.$v.blockTrigger.submissionSession.$touch();
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref) {
        var _item$semester, _item$year;

        var item = _ref.item;
        return [_c('span', {
          staticStyle: {
            "font-size": "14px"
          }
        }, [_vm._v(" " + _vm._s("".concat((_item$semester = item.semester) === null || _item$semester === void 0 ? void 0 : _item$semester.name, " ").concat((_item$year = item.year) === null || _item$year === void 0 ? void 0 : _item$year.name)) + " ")])];
      }
    }, {
      key: "item",
      fn: function fn(_ref2) {
        var _item$semester2, _item$year2;

        var item = _ref2.item;
        return [_c('span', {
          staticStyle: {
            "font-size": "14px"
          }
        }, [_vm._v(" " + _vm._s("".concat((_item$semester2 = item.semester) === null || _item$semester2 === void 0 ? void 0 : _item$semester2.name, " ").concat((_item$year2 = item.year) === null || _item$year2 === void 0 ? void 0 : _item$year2.name)) + " ")])];
      }
    }]),
    model: {
      value: _vm.blockTrigger.submissionSession,
      callback: function callback($$v) {
        _vm.$set(_vm.blockTrigger, "submissionSession", $$v);
      },
      expression: "blockTrigger.submissionSession"
    }
  })], 1), _c('v-col', {
    staticClass: "pt-0 pb-6",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('DateField', {
    attrs: {
      "date": _vm.blockTrigger.startDateTime,
      "max": _vm.blockTrigger.endDateTime,
      "label": "Дата начала"
    },
    on: {
      "updateDate": _vm.updateStartDateTime
    }
  })], 1), _c('v-col', {
    staticClass: "pt-0 pb-6",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('TimeField', {
    attrs: {
      "time": _vm.blockTrigger.startDateTime,
      "max": _vm.blockTrigger.endDateTime,
      "label": "Время начала"
    },
    on: {
      "updateTime": _vm.updateStartDateTime
    }
  })], 1), _c('v-col', {
    staticClass: "pt-0 pb-6",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('DateField', {
    attrs: {
      "date": _vm.blockTrigger.endDateTime,
      "min": _vm.blockTrigger.startDateTime,
      "label": "Дата окончания"
    },
    on: {
      "updateDate": _vm.updateEndDateTime
    }
  })], 1), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('TimeField', {
    attrs: {
      "time": _vm.blockTrigger.endDateTime,
      "min": _vm.blockTrigger.startDateTime,
      "label": "Время окончания"
    },
    on: {
      "updateTime": _vm.updateEndDateTime
    }
  })], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "px-6"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "lightGrey"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Отмена")]), _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.$v.$invalid,
      "color": "success",
      "text": ""
    },
    on: {
      "click": _vm.saveBlockTrigger
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? 'Сохранить' : 'Создать') + " ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }